import { render } from "./StaticSidebar.vue?vue&type=template&id=d3f4628c&scoped=true"
import script from "./StaticSidebar.vue?vue&type=script&lang=js"
export * from "./StaticSidebar.vue?vue&type=script&lang=js"

import "./StaticSidebar.vue?vue&type=style&index=0&id=d3f4628c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f4628c"]])

export default __exports__